const isRequired = (v: string | undefined, name: string) => (v ? undefined : `${name} is required`);

export const validations = { isRequired };
